import { html, rune, View } from 'rune-ts';
import { typoPcMo } from '../../../../../shared/typography/typo';
import klass from './CreatorInputFile.module.scss';

interface FileItemProps {
  file_id: number;
  original_name: string;
  url: string;
}

export class FileItem extends View<FileItemProps> {
  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const file = this.data;

    return html`
      <li
        url="${file.url}"
        file_id="${file.file_id}"
        name="${file.original_name}"
        class="${typoPcMo({
          is_mobile,
          pc: '14_medium',
          mo: '12_medium',
        })}"
      >
        ${file.original_name}
        <button
          type="button"
          class="${klass.btn_delete_file} ${typoPcMo({
            is_mobile,
            pc: '12_medium',
            mo: '10_medium',
          })}"
        >
          ${ET('mps2::ad_res::delete')}
        </button>
      </li>
    `;
  }
}
